import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Property } from "../../types";
import { Box, Stack, Typography } from "@mui/material";
import AddSubProperty from "./add-sub-property";
import { useSubpropertiesQuery } from "../../hooks/sub-properties.hook";
import SubPropertyCollapsibleCard from "../property/collapsible-card/collapsible-card";
import SubPropertiesEmptyState from "./empty-state";
import LoadingSkeleton from "@/modules/common/components/ui/loadingSkeleton";

function SubpropertiesTabMobile({
  open,
  onClose,
  property,
  trackTypeName,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  property: Property;
  trackTypeName?: string;
}>) {
  const { data: subProperties, isLoading } = useSubpropertiesQuery({
    uid: property.uid,
  });

  const hasSubProperties = subProperties && subProperties.length > 0;

  if (isLoading) return <LoadingSkeleton heights={["100"]} rows={3} />;

  return (
    <FullPageModal
      isOpen={open}
      onClose={onClose}
      title={
        <Stack
          direction="row"
          alignItems="center"
          gap={(theme) => theme.nawy.spacing.xxs}
        >
          <Typography
            sx={(theme) => theme.nawy.typography.english.variants.headline.xs}
          >
            Sub Properties
          </Typography>
          {hasSubProperties && (
            <Typography
              sx={(theme) =>
                theme.nawy.typography.english.variants.body.sm.regular
              }
            >
              ({subProperties?.length ?? 0})
            </Typography>
          )}
        </Stack>
      }
      extraButtons={
        <AddSubProperty
          property={property}
          hasLabel={false}
          trackTypeName={trackTypeName}
        />
      }
    >
      {hasSubProperties ? (
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: theme.nawy.spacing.md,
            py: theme.nawy.spacing.md,
          })}
        >
          {subProperties.map((property) => (
            <SubPropertyCollapsibleCard
              key={property.uid}
              property={property}
            />
          ))}
        </Box>
      ) : (
        <SubPropertiesEmptyState property={property} trackTypeName={trackTypeName} />
      )}
    </FullPageModal>
  );
}

export default SubpropertiesTabMobile;
